/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prompt_Tips_TooltipInputs */

const es_prompt_tips_tooltip = /** @type {(inputs: Prompt_Tips_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips para mejores resultados`)
};

const en_prompt_tips_tooltip = /** @type {(inputs: Prompt_Tips_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips for better results`)
};

/**
* | output |
* | --- |
* | "Tips for better results" |
*
* @param {Prompt_Tips_TooltipInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const prompt_tips_tooltip = /** @type {((inputs?: Prompt_Tips_TooltipInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prompt_Tips_TooltipInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prompt_tips_tooltip(inputs)
	return en_prompt_tips_tooltip(inputs)
});
export { prompt_tips_tooltip as "prompt_tips.tooltip" }